export class TalkUnreadCountMismatchError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "TalkUnreadCountMismatchError";
  }
}
